import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="border-t border-[#ffffff10] bg-[#020308] py-12 relative z-10" data-id="element-31">
      <div className="container mx-auto px-6" data-id="element-32">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-33">
          <div className="text-2xl font-bold font-['Orbitron']" data-id="element-34">
            CASINOLIVE<span className="text-[#ff006e]" data-id="element-35">.WEBSITE</span>
          </div>
          <div className="flex gap-8 font-mono text-xs text-gray-500" data-id="element-36">
            <Link to="/privacy" className="hover:text-[#00f0ff] transition-colors" data-id="element-37">
              PRIVACY POLICY
            </Link>
            <a href="#" className="hover:text-[#00f0ff] transition-colors" data-id="element-38">
              TERMS OF SERVICE
            </a>
            <span data-id="element-39">© 2077  CASINOLIVE .</span>
          </div>
        </div>
      </div>
    </footer>;
}